<template>
    <div>
        <convenios
            :ConveniosServicos="obterDataServicos()"
            rotaDetalhar="Gescon_Convenios_Gestor_Detalhar"
            rotaListagem="Gescon_Convenios_Gestor"
            :temAcessoDetalhar="$temAcessoView('GESCON-GEST-CONV-02')"
        ></convenios>
        <router-view></router-view>
    </div>
</template>

<script>
import ConveniosServicos from './ConvenioServicos'
import Convenios from '../componentes/ConvenioLista'

export default {
    components: {
        Convenios
    },

    methods: {
        obterDataServicos() {
            return ConveniosServicos
        }
    },
}
</script>

